import {BaseService} from "@/api/baseService";

export interface Event<DateType = string> {
    id: string;
    name: string;
    link: string;
    location: string;
    focus: string;
    startDate: DateType;
    endDate: DateType;
    createdAt: DateType;
    updatedAt: DateType;
}

export class EventService extends BaseService {
    public static async getEvents(): Promise<Event[]>  {
        const events =  await this.getData<Event[]>('/events');
        return events;
    }
}
